import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        window.setTimeout(() => {
          if (window.__lenis) {
            window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
          } else {
            el.scrollIntoView({ behavior: "auto" });
          }
        }, 350);
        return;
      }
    }
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
